<div
  class="wrapper flex column"
  [class.close]="!open() || isMobile()"
>
  <div class="logo-box flex hcenter vcenter">
    @if (open() && !isMobile()) {
      <img
        alt=""
        class="logo"
        src="assets/shared/global-images/payee-logos/v1/white-payee-with-badge.svg"
        width="100px"
        routerLink="cases"
        [queryParams]="clientFilterQueryParams()"
      />
    }
    @if (!open() || isMobile()) {
      <img
        alt=""
        class="logo"
        src="assets/shared/global-images/payee-logos/v1/payee-webclip-white.svg"
        width="56.83px"
        routerLink="cases"
        [queryParams]="clientFilterQueryParams()"
      />
    }
  </div>

  <div class="sidebar-nav flex column">
    <div class="client-selector-container">
      <div class="company-selector-wrapper">
        <button
          color="white"
          payee-button
          width="max"
          matTooltipPosition="right"
          class="company-selector-button"
          [matMenuTriggerFor]="companyMenu"
          [isRoundButton]="false"
          [matTooltip]="displayedClientName() || ('SIDEBAR.ALL_CLIENTS' | translate)"
          [matTooltipDisabled]="open()"
        >
          <span class="selected-client-name">{{ displayedClientName() || ("SIDEBAR.ALL_CLIENTS" | translate) }}</span>
          <img
            alt=""
            class="arrow-icon"
            src="assets/shared/global-images/icon-set/arrow-down-grey-no-shaft.svg"
          />
        </button>

        <mat-menu
          #companyMenu="matMenu"
          class="company-selector-menu"
        >
          <div class="company-menu-header">
            <div class="company-name">
              {{ displayedClientName() || ("SIDEBAR.ALL_CLIENTS" | translate) }}
            </div>
          </div>

          <div class="company-menu-section">
            <button
              mat-menu-item
              (click)="navigateToClientProfile()"
            >
              <div class="flex vcenter">
                <img
                  alt=""
                  src="assets/shared/global-images/icons/gear.svg"
                  class="menu-icon"
                />
                <span>{{ "SIDEBAR.SETTINGS" | translate }}</span>
              </div>
            </button>
            @if (isProduction) {
              <a
                mat-menu-item
                href="https://sandbox.payee.tech"
                target="_blank"
              >
                <img
                  alt=""
                  src="assets/shared/global-images/icons/lock-grey.svg"
                  class="menu-icon"
                />
                <span>{{ "SIDEBAR.SWITCH_TO_SANDBOX" | translate }}</span>
                <payee-icon
                  name="arrow-right-grey"
                  class="menu-arrow"
                ></payee-icon>
              </a>
            }
          </div>

          <div class="company-menu-section company-list-section">
            @if (hasMultipleClients()) {
              <button
                mat-menu-item
                (click)="selectClient(null)"
              >
                <span>{{ "SIDEBAR.ALL_CLIENTS" | translate }}</span>
              </button>
            }
            @for (client of clientOptions(); track client.id) {
              <button
                mat-menu-item
                (click)="selectClient(client)"
              >
                <span>{{ client.name || "SIDEBAR.CLIENT_PH" | translate }}</span>
              </button>
            }
          </div>

          <div class="menu-separator"></div>

          <div class="company-menu-section">
            <button
              mat-menu-item
              (click)="navigateToUserProfile()"
            >
              <div class="flex vcenter">
                <img
                  alt=""
                  src="assets/shared/global-images/icons/user.svg"
                  class="menu-icon"
                />
                <span>{{ userName() }}</span>
              </div>
            </button>
            <button
              mat-menu-item
              (click)="logout()"
            >
              <div class="flex vcenter">
                <payee-icon
                  name="logout-red"
                  class="menu-icon"
                ></payee-icon>
                <span>{{ "SIDEBAR.SIGN_OUT" | translate }}</span>
              </div>
            </button>
          </div>
        </mat-menu>
      </div>
    </div>

    <div class="create-case-button-container flex vcenter top-margin-15">
      <button
        payee-button
        routerLink="/cases/wizard"
        [isRoundButton]="false"
      >
        <img
          alt=""
          src="/assets/shared/global-images/icons/plus-white.svg"
          width="14px"
          height="14px"
        />
        @if (open() && !isMobile()) {
          <span>&nbsp;{{ "SIDEBAR.CREATE_CASE" | translate }}</span>
        }
      </button>
    </div>

    @if (hasSzamlazzhuPartner()) {
      <div class="szamlazzhu-continue-button-container flex vcenter top-margin-15">
        <a
          class="szamlazzhu-continue-link"
          href="https://www.szamlazz.hu/digitalis-koveteleskezeles/"
          target="_blank"
          rel="noopener noreferrer"
          matTooltipPosition="right"
          matTooltipClass="sidebar-tooltip"
          [matTooltip]="open() ? '' : ('SIDEBAR.CONTINUE_WITH_SZAMLAZZ' | translate)"
          [attr.aria-label]="'SIDEBAR.CONTINUE_WITH_SZAMLAZZ' | translate"
        >
          @if (open() && !isMobile()) {
            <img
              alt=""
              class="szamlazzhu-sidebar-img"
              src="assets/shared/global-images/case-form/invoice/szamlazzhu.png"
            />
          }
          @if (!open() || isMobile()) {
            <img
              alt=""
              class="szamlazzhu-sidebar-img"
              src="assets/shared/global-images/partner-logos/mini-logos/szamlazzhu.svg"
            />
          }
        </a>
      </div>
    }

    <div
      class="menu-button flex vcenter top-margin-15"
      routerLinkActive="active"
      routerLink="cases"
      matTooltipPosition="right"
      matTooltipClass="sidebar-tooltip"
      [queryParams]="clientFilterQueryParams()"
      [matTooltip]="open() ? '' : ('SIDEBAR.MY_CASES' | translate)"
    >
      <img
        alt=""
        class="menu-icon"
        src="assets/shared/global-images/icons/list.svg"
      />
      <span [class.close]="!open() || isMobile()">{{ "SIDEBAR.MY_CASES" | translate }}</span>
    </div>

    <div
      class="menu-button flex vcenter top-margin-15"
      routerLinkActive="active"
      routerLink="events"
      matTooltipPosition="right"
      matTooltipClass="sidebar-tooltip"
      [queryParams]="clientFilterQueryParams()"
      [matTooltip]="open() ? '' : ('SIDEBAR.EVENTS' | translate)"
    >
      <img
        alt=""
        class="menu-icon menu-icon-light"
        src="assets/shared/global-images/icons/calendar.svg"
      />
      <span [class.close]="!open() || isMobile()">{{ "SIDEBAR.EVENTS" | translate }}</span>
    </div>
  </div>

  <div class="sidebar-footer">
    <a
      class="payee-email"
      [class.close]="!open() || isMobile()"
      [href]="'mailto:' + payeeEmail()"
    >
      {{ payeeEmail() }}
    </a>
    <div
      class="version"
      [class.close]="!open() || isMobile()"
    >
      {{ "SIDEBAR.VERSION" | translate }}
      <strong #appVersion>v{{ versionNumber }}</strong>
    </div>
    @if (!isMobile()) {
      <button
        mat-button
        class="toggle-button"
        [class.close]="!open()"
        (click)="toggleOpen()"
      >
        @if (open()) {
          <img
            alt=""
            width="12px"
            src="assets/shared/global-images/icons/arrow-double-left-grey.svg"
          />
        }
        @if (!open()) {
          <img
            alt=""
            width="12px"
            src="assets/shared/global-images/icons/arrow-double-right-grey.svg"
          />
        }
      </button>
    }
  </div>
</div>
